import { Typography, Row, Col } from 'antd';
import React from 'react';
const { Title, Paragraph, Text } = Typography;
const Home = () => {
    return (
        <Row gutter={[32, 32]} justify="center">
            <Col span={24}>
                <Row justify={"center"} >
                    <Col span={"auto"}>
                        <Title level={1}>關於計畫</Title>
                    </Col>
                </Row>
                <Row gutter={[8, 8]} justify={"center"}>
                    <Col span={"auto"}>
                        <Title level={3}>計畫源起</Title>
                    </Col>
                    
                    <Col span={24}>
                        <Paragraph style={{textAlign:"center",padding:'0% 20%'}}>
                            國家競爭力源自於教育力,教育力的根本在語文教育,舉凡閱讀、理解、思維、表達、均取決於語文教育。經典誦讀不僅是語文思想的教育,更是品格文化素養的教育,在分心的時代更是專注力培育的最佳途徑。林岱樺立委深感於此,特針對高雄地區國小如何強化語文教育及文化傳承之必要召開會議,確立以經典教育落實品格養成,扎實語文根柢。
                        </Paragraph>
                        <Paragraph style={{textAlign:"center",padding:'0% 20%'}}>
                            本計畫將銜接以推廣經典朗讀為核心之「提升高雄市國小學生國語文經典學習成效實驗計畫」,在其所建立的基礎下,持續擴展為以應用表達為主的實驗計畫。演說、朗讀、作文為全國語文競賽中的重要項目,亦是各級學校教師苦無合宜的教材及示範作為菁英學生訓練之用,更遑論給一般學生的培力?是以本計畫在學生已有經典文本的資糧下,趁勝追擊,持續發展表達應用,建構完整訓練教材及演練示範,期使培育學生皆具有運用經典文本,能說能寫能演雅俗共賞的表達能力。
                        </Paragraph>
                    </Col>
                    <Col span={"auto"}>
                        <Title level={3}>計畫目標</Title>
                    </Col>
                    <Col span={24} >
                        <Row justify={"center"} style={{padding:'0% 20%'}}>
                            <Col span={24}>
                                <Text>
                                    一、積極強化落實國小語文經典教育扎根。
                                </Text>
                                <br />
                                <br />
                                <Text>
                                    二、編修國小語文經典表達寫作講說教材。
                                </Text>
                                <br />
                                <br />
                                <Text>
                                    三、建立經典教育推展工作支持系統。
                                    <ul style={{listStyleType: 'none'}}>
                                        <li>
                                            <ol type='1'>
                                                <li>辦理種子教師培訓。</li>
                                                <li>研發教法。</li>
                                                <li>建置群科諮詢輔導機制,推動種子教師社群。</li>
                                            </ol>
                                        </li>
                                    </ul>
                                </Text>
                                <Text>
                                    四、辦理表達力推廣課程間及鄰近屏東縣市及台南市。
                                </Text>
                                <br />
                                <br />
                                <Text>
                                    五、辦理經典表達力展演等各項推廣教育示範活動。
                                </Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            
        </Row >
    )
};
export default Home;